import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  name: string;
  onViewDetails: () => void;
}

const WelcomeHero: React.FC<Props> = ({ name, onViewDetails }) => {
  const { t } = useTranslation();

  return (
    <section className="mb-5 border-s-2 border-[#bf0035] bg-[#bf0035]/[0.03] px-5 py-5 text-start sm:px-6 sm:py-6">
      <div className="mb-2 flex items-center justify-between gap-4">
        <p className="text-xs font-semibold uppercase tracking-[0.14em] text-[#bf0035]">
          {t('portal.hero.badge')}
        </p>
        <button
          type="button"
          onClick={onViewDetails}
          className="rounded-lg border border-[#bf0035]/20 bg-white px-3 py-1.5 text-xs font-semibold text-[#bf0035] transition-colors hover:bg-[#bf0035]/[0.05]"
        >
          {t('portal.viewDetails')}
        </button>
      </div>
      <h1 className="text-2xl font-extrabold leading-tight text-gray-900 sm:text-3xl">
        {t('portal.hero.greeting', { name })}
      </h1>
      <p className="mt-2 max-w-xl text-sm leading-relaxed text-gray-600 sm:text-base">
        {t('portal.hero.subtitle', { name })}
      </p>
    </section>
  );
};

export default WelcomeHero;
